import { ServerAPI } from '../GeneralFunction';

const LoginLogoutApi = {
	login: (data) => {
		let url = "login";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	logout: () => {
		let url = "logout";
		const requestOptions = ServerAPI(url, 'GET');
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	supportlogin: (data) => {
		let url = "support_login";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	supportlogout: () => {
		let url = "support_logout";
		const requestOptions = ServerAPI(url, 'GET');
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	resetpassword: (data) => {
		let url = "reset_password";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getmemberlist: (data) => {
		let url = "get_member_list";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	forgotpassword: (data) => {
		let url = "forgot_password";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getaccountsetupdetails: () => {
		let url = "get_account_setup_details";
		const requestOptions = ServerAPI(url, 'GET');
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	saveaccountsetup: (data) => {
		let url = "save_account_setup";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	saveonboardingstep: (data) => {
		let url = "save_onboarding_step";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getonboardingdata: () => {
		let url = "get_onboarding_data";
		const requestOptions = ServerAPI(url, 'GET');
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	}
};

export default LoginLogoutApi;
